import {EditorSDK, EditorType} from '@wix/platform-editor-sdk';
import {EditorScriptFlowAPI} from '@wix/yoshi-flow-editor';

import {createIsMultilingualModeEnabled} from '@/api/isMultilingualModeEnable';
import {addLanguageSelector} from '@/components';
import {openDashboardModal} from '@/panels';
import {MultilingualDashboardUrlPath} from '@/types';

type HandleAppInstalled = (
  editorSDK: EditorSDK,
  panoramaClient: EditorScriptFlowAPI['panoramaClient'],
  biLogger: EditorScriptFlowAPI['bi'],
  editorType: EditorType,
  appInstance: string,
) => Promise<void>;

export const handleAppInstalled: HandleAppInstalled = async (
  editorSDK,
  panoramaClient,
  biLogger,
  editorType,
) => {
  panoramaClient?.transaction('appInstalledEvent').start();

  await addLanguageSelector(editorSDK, '', editorType, biLogger);

  const isMultilingualModeEnabled = await createIsMultilingualModeEnabled()();

  if (!isMultilingualModeEnabled) {
    openDashboardModal(editorSDK, '', MultilingualDashboardUrlPath.ONBOARDING);
  }

  panoramaClient?.transaction('appInstalledEvent').finish();
};
